import { useActivityContext } from "@Context/game/activity/activity-context";
import ActivityEmptyState from "@Components/game/activity/activity-empty-state";
import ActivityHero from "@Components/game/activity/activity-hero";
import ActivityLoadingState from "@Components/game/activity/activity-loading-state";
import ActivitySessions from "@Components/game/activity/activity-sessions";
import { ActivitySection } from "@Components/game/activity/styled-components";

const ActivityContent = () => {
  const { groupedSessions, isInitialLoading } = useActivityContext();

  return (
    <ActivitySection>
      <ActivityHero />

      {isInitialLoading ? <ActivityLoadingState /> : groupedSessions.length === 0 ? <ActivityEmptyState /> : <ActivitySessions />}
    </ActivitySection>
  );
};

export default ActivityContent;
